import CurrencySelector from './currency-selector';

export default CurrencySelector;
